<template>
  
  <div style="display: inline-flex">

    <Button :label="$t('library.cycle.info_button')" 
        class="p-button-outlined" icon="icon-info" iconPos="left" 
        @click="buttonClick" />
  
    <Dialog :visible="dialog.info" class="recipe-info-dialog" :modal="true" 
    :closable="true" :dismissableMask="true" :style="{width: '90vw', minWidth: '460px'}" :breakpoints="{'820px': '100vw'}" :draggable="false"
    @update:visible="updateVisible">
      
      <template #header>
        <div class="p-grid p-m-0 recipe-info-dialog-header" style="width:100%">
          <div class="p-col-12 p-md-7 p-pl-0 p-d-inline-flex p-ai-center">
            <span :class="'p-mr-2 icon-mf_cycle_image_'+(recipe.image).toString().padStart(4, '0')" style="font-size: 35px"/>
            {{recipe.name}}
          </div>
          <div class="p-col-12 p-md-5 p-pl-0 p-d-inline-flex p-ai-center ">
            <span :class="'p-mr-2 icon-mf_function_'+(recipe.function).toString().padStart(2, '0')" style="font-size: 35px;"/>
            {{$t('mf.functions.'+recipe.function)}}
          </div>
        </div>
      </template>
      
      <div class="">
          <div class="title">
            {{$t('library.steps.info.description')}}
          </div>
          <div class="text">
            {{recipe.description}}
          </div>
      </div>

      <div class="p-mt-4 p-grid">
        <div class="p-col-12 p-sm-6 p-md-6 p-lg-3">
          <div class="title">
            {{$t('library.steps.info.stats_creation_date')}}
          </div>
          <div class="text">
            {{formatTime(recipe.creation)}}
          </div>
        </div>
        <div class="p-col-12 p-sm-6 p-md-6 p-lg-3">
          <div class="title">
            {{$t('library.steps.info.stats_last_used_date')}}
          </div>
          <div class="text">
            {{formatTime(recipe.last_run)}}
          </div>
        </div>
        <div class="p-col-12 p-sm-6 p-md-6 p-lg-3">
          <div class="title">
            {{$t('library.steps.info.stats_last_edit_date')}}
          </div>
          <div class="text">
            {{formatTime(recipe.last_change)}}
          </div>
        </div>
        <div class="p-col-12 p-sm-6 p-md-6 p-lg-3">
          <div class="title">
            {{$t('library.steps.info.stats_usage_counter')}}
          </div>
          <div class="text">
            {{recipe.num_runs ?? 0}}
          </div>
        </div>
      </div>

      <template #footer></template>
      
    </Dialog>
  </div>
    
</template>

<script>
import RecipeService from '../../../service/RecipeService';
import { mapGetters } from 'vuex';

export default {

  components: {
    },
    props: {
      serialNumber: String,
      recipe: Object,
      appliance: Object
    },
    data() {
        return {
          dialog: {
            error: false,
            info: false
          },
        };
    },
    computed: {
      ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          isCelsius: 'userdata/isCelsius',
          is24hour: 'userdata/is24hour',
        }),
    },
    watch: {
    },
    created() {
      this.recipeService = new RecipeService();
    },
    mounted() {
    },
    methods: {
      buttonClick() {
        this.dialog.info = true;
      },
      updateVisible(value) {
        if(!value) {
          this.dialog.info = false;
        }
      },
      formatTime(timestamp) {
        if(!timestamp) return "N/A";
        try {
          if(this.is24hour) {
            return this.$d(new Date(timestamp*1000), "long");
          } else {
            return this.$d(new Date(timestamp*1000), "long12");
          }
        } catch(err) {
          console.error(err);
          return "N/A";
        }
      }
    }

}
</script>

<style scoped>

</style>